import {environment} from "../../../../environments/environment";

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const SubcontractorApiResources = {
  list:  createUrl('subcontractors'),
  create:  createUrl('subcontractors/create'),
  copy: createUrl('subcontractors/copy'),
  detail:  createUrl('subcontractors'),
  update:  createUrl('subcontractors'),
  delete:  createUrl('subcontractors'),
  deleteMultiple:  createUrl('subcontractors/delete/multiple'),
  deleteAvailability:  createUrl('subcontractors/delete/availability'),
  attachSkill:  createUrl('subcontractors/skill/attach'),
  detachSkill:  createUrl('subcontractors/skill/detach'),
  // Import endpoints
  downloadSample: createUrl('subcontractors/import/sample'),
  uploadImport: createUrl('subcontractors/import/upload'),
  validateImport: createUrl('subcontractors/import/validate'),
  executeImport: createUrl('subcontractors/import/execute'),
  importStatus: createUrl('subcontractors/import/status'),
  importHistory: createUrl('import-history'),
};
